<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path d="M4 7.99996L6.82843 10.8284L12.4847 5.17151" stroke="#2BCAB2" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
</template>
<script>
const checkIcon = {
    name: 'checkIcon',
}
export default checkIcon
export { checkIcon }
</script>